import REST from './rest';

class WPAPI extends REST {
    constructor() {
        super();
        this.baseURL = 'https://hubton.com/wp-json/wp/v2';
    }

    /**
     * Get Portfolio
     */
    getPortfolio(params = null) {
        return this._request('get', 'portfolio', params);
    }

    /**
     * Get Blog
     */
    getBlog(params = null) {
        return this._request('get', 'posts', params);
    }
}

const api = new WPAPI();

export default api;




// WEBPACK FOOTER //
// ./src/api/wp.js